"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBuildTestId = useBuildTestId;
var _useBuildTestIdInternal = require("./internal/useBuildTestIdInternal");
function useBuildTestId(_ref) {
  var identifier = _ref.identifier,
    suffix = _ref.suffix,
    componentName = _ref.componentName,
    testId = _ref.testId;
  return (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: identifier,
    suffix: suffix,
    componentName: componentName
  });
}
//# sourceMappingURL=useBuildTestId.js.map